import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import firebaseAuthService from '../services/firebaseAuth';

const BG_COLOR = '#E6F0FF';
const ACCENT = '#1F4ECF';

const CARD_W = 370;
const CARD_H = 531;

const RegisterForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await firebaseAuthService.register(email, password, name);
      if (result?.success) {
        navigate('/login');
      } else {
        setError(result?.error || 'Registration failed');
      }
    } catch (err) {
      setError('Registration failed: ' + (err?.message || String(err)));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-screen h-screen overflow-hidden" style={{ backgroundColor: BG_COLOR }}>
      {/* Background SVG (10% opacity) */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/bg.svg')",
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'full',
          opacity: 0.3,
          zIndex: 0,
        }}
      />

      {/* Logo */}
      <div style={{ position: 'absolute', top: 24, left: 32, zIndex: 2 }}>
        <img src="/bidz-logo.svg" alt="BidZ" style={{ height: 40 }} />
      </div>

      {/* Centered Card */}
      <div className="flex items-center justify-center w-full h-full relative z-10">
        <div
          role="region"
          aria-label="Register"
          style={{
            width: CARD_W,
            height: CARD_H,
            borderRadius: 12,
            background: 'rgba(255,255,255,0.98)',
            boxShadow: '0 20px 40px rgba(16,40,80,0.18)',
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 30,
              left: 0,
              right: 0,
              textAlign: 'center',
              fontSize: 24,
              fontWeight: 700,
            }}
          >
            Register
          </div>

          <form onSubmit={handleSubmit}>
            {/* Name */}
            <div style={{ position: 'absolute', left: 35, top: 96, width: 300 }}>
              <label style={{ fontSize: 14, fontWeight: 500 }}>Name</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="i.e. John Doe"
                required
                style={{
                  width: '100%',
                  height: 50,
                  marginTop: 6,
                  padding: '0 12px',
                  borderRadius: 8,
                  border: `1.5px solid ${ACCENT}`,
                  outline: 'none',
                }}
              />
            </div>

            {/* Email */}
            <div style={{ position: 'absolute', left: 35, top: 196, width: 300 }}>
              <label style={{ fontSize: 14, fontWeight: 500 }}>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="i.e. johndoe@gmail.com"
                required
                style={{
                  width: '100%',
                  height: 50,
                  marginTop: 6,
                  padding: '0 12px',
                  outline: 'none',
                  borderRadius: 8,
                  border: `1.5px solid ${ACCENT}`,
                }}
              />
            </div>

            {/* Password */}
            <div style={{ position: 'absolute', left: 35, top: 296, width: 300 }}>
              <label style={{ fontSize: 14, fontWeight: 500 }}>Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  style={{
                    width: '100%',
                    height: 50,
                    marginTop: 6,
                    padding: '0 42px 0 12px',   // space for eye icon
                    borderRadius: 8,
                    outline: 'none',
                    border: `1.5px solid ${ACCENT}`,
                    boxSizing: 'border-box',
                  }}
                />

                {/* Eye Icon */}
                <img
                  src="/eye-icon.svg"
                  alt="Show password"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: 12,
                    top: '55%',
                    transform: 'translateY(-50%)',
                    width: 20,
                    height: 20,
                    cursor: 'pointer',
                    opacity: showPassword ? 1 : 0.5,
                    color: '#232323ff',
                  }}
                />
              </div>

            </div>

            {/* Button */}
            <button
              type="submit"
              disabled={loading}
              style={{
                position: 'absolute',
                left: 35,
                top: 396,
                width: 300,
                height: 56,
                backgroundColor: ACCENT,
                color: '#fff',
                borderRadius: 10,
                border: 'none',
                fontSize: 16,
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              {loading ? 'Registering...' : 'Register'}
            </button>
          </form>

          {/* Error */}
          {error && (
            <div
              style={{
                position: 'absolute',
                left: 20,
                right: 20,
                bottom: 70,
                background: '#FEE2E2',
                color: '#991B1B',
                padding: 8,
                borderRadius: 6,
                textAlign: 'center',
                fontSize: 13,
              }}
            >
              {error}
            </div>
          )}

          {/* Footer */}
          <div
            style={{
              position: 'absolute',
              bottom: 22,
              width: '100%',
              textAlign: 'center',
              fontSize: 14,
            }}
          >
            Already have an account?{' '}
            <button
              onClick={() => navigate('/login')}
              style={{
                background: 'none',
                border: 'none',
                color: ACCENT,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
